import React from 'react'
import PropTypes from 'prop-types'

import SvgIcon from 'Components/SvgIcon'


const FilterTag = ({ className = '', onMouseDown = null, value = null }) => (
  <div
    data-test-id={'filterTag'}
    className={className}
    onMouseDown={onMouseDown}
  >
    <div
      // eslint-disable-next-line
      dangerouslySetInnerHTML={{ __html: value }}
    />
    <SvgIcon name={'#icon-close'} width={12} height={12} className={'closeIcon'}/>
  </div>
)

FilterTag.propTypes = {
  className: PropTypes.string,
  onMouseDown: PropTypes.func,
  value: PropTypes.string,
}

export default FilterTag
